const REGION_SUFFIX_REGEX =
    /(область|край|республика|автономная область|автономный округ|округ)/i

const shortAddress = address => {
    if (!address) return '-'

    const parts = address.split(',').map(part => part.trim())
    let rest = parts.slice(1)

    if (rest.length && REGION_SUFFIX_REGEX.test(rest[0])) {
        rest = rest.slice(1)
    }

    return rest.join(', ')
}

export { shortAddress }